import BaseViz from './BaseViz'
import ChoroplethChart from '../charts/ChoroplethChart'
import ChoroplethDataController from '../viz_behaviors/ChoroplethDataController'
export default class ChoroplethViz extends BaseViz {
  static defaultConfig = {
    LegendBehavior:{
      showLegend: {
        value: true,
      }
    },
  }
  static chartClass = ChoroplethChart
  static dataControllerClass = ChoroplethDataController
}
